import React, { Component } from 'react';
import { PartnerSetupError } from '../components/PartnerSetupError/PartnerSetupError';

export class PartnerSetupErrorPage extends Component {
  render() {
    return (
      <div style={{ height: '100vh' }}>
        <PartnerSetupError />
      </div>
    );
  }
}
